module.exports = __webpack_public_path__ + "img/bg-4.61b63d4e.png";